import { defineComponent } from 'navigation-components/platform/models';
import { GROWTH_IN_APP_SIDEPANEL_COMPONENT } from '../constants';
import { getPortalId } from '../../common/utils';
import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
import { growthInAppSidepanelIframeStyle } from './internal/getStyle';
export const growthInAppSidepanelComponentDef = defineComponent(GROWTH_IN_APP_SIDEPANEL_COMPONENT, {
  path: `/growth-in-app-sidepanel/${getPortalId()}`,
  name: GROWTH_IN_APP_SIDEPANEL_COMPONENT,
  capabilities: [capabilities.RESTYLE_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.NAVIGATE_TO_CAP.getName()],
  iframeProps: {
    id: 'growth-in-app-sidepanel',
    style: growthInAppSidepanelIframeStyle
  },
  propsSchema: {
    source: args.string(),
    context: args.string(),
    onboardingTourId: args.string()
  },
  initialProps: {
    source: '',
    context: '',
    onboardingTourId: ''
  }
});